import { deserialize } from 'cerialize'
import { NotificationTemplateChannelModel } from 'Pages/admin/notification/models/notificationTemplateChannel'
import { RoleModel } from 'Models'

export class TemplateModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public slug: string
	@deserialize public group: string
	@deserialize public engine: string
	@deserialize public store_days: string
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public roles: RoleModel[]
	@deserialize public notification_template_channels: NotificationTemplateChannelModel[]
	@deserialize public message_template?: string
}
